// @ts-ignore
/* eslint-disable */
import type { CustomRequestOptions } from '../customRequestOptions';
import { request } from '../axios/sdpMerchant';

/** 确认并同意隐私政策 GET /mch/privacy/policy/confirm */
export async function privacyPolicyConfirm(options?: CustomRequestOptions) {
  return request<APISdpMerchant.GatewayResponse>('/mch/privacy/policy/confirm', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 查询隐私政策信息及当前用户是否需要确认 GET /mch/privacy/policy/query */
export async function privacyPolicyQuery(options?: CustomRequestOptions) {
  return request<APISdpMerchant.GatewayDataResponseBoolean_>('/mch/privacy/policy/query', {
    method: 'GET',
    ...(options || {}),
  });
}
